<template>
    <v-container class="mt-12 pt-8" style="background:#fafafa;">
        <v-row style="background:#fafafa;">
            <v-col cols="12" class="pa-0">
                <v-row class="py-1 px-5" align="center" justify="center">
                    <v-col cols="8" md="8" LeadsPannel>
                        <v-row>
                            <v-col cols="12" LEADSPANEL>
                                <v-card :loading="loading">
                                    <v-card-text class="py-0">
                                        <v-row class="align-center">
                                            <v-col cols="12">
                                                <v-row class="align-center">
                                                    <v-col cols="12" TITLE>
                                                        <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">
                                                            {{ i18n['add_plan'] }}</div>
                                                    </v-col>
                                                </v-row>
                                            </v-col>

                                            <v-col cols="12" class=" py-0">
                                                <v-form ref="form" @submit.prevent="submitPlans">
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col cols="12">
                                                                        <v-switch v-model="is_free" :class="[{'arFont': arabic, 'enFont': !arabic},'mb-2']" label="Is Free" color="success" dense inset>
                                                                        </v-switch>
                                                                    </v-col>
                                                                    <v-col cols="6" v-if="!is_free">
                                                                        <v-text-field outlined dense v-model="price_id" :label="i18n['price_id']"
                                                                            :class="`${arabic ? 'arFont' : 'enFont'}`"
                                                                            :rules="[rules.requiredIfNotFree]" required></v-text-field>
                                                                        </v-col>
                                                                   <v-col cols="6">
                                                                <v-text-field outlined dense v-model="title"
                                                                    :label="i18n['title']"
                                                                    :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <v-text-field outlined dense v-model="title_ar"
                                                                    :label="i18n['title_ar']"
                                                                    :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <v-text-field outlined dense v-model="description"
                                                                    :label="i18n['description']"
                                                                    :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <v-text-field outlined dense v-model="description_ar"
                                                                    :label="i18n['description_ar']"
                                                                    :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </v-col>

                                                            <v-col cols="6">
                                                                <v-text-field outlined dense v-model="price"
                                                                    :label="i18n['price']"
                                                                    :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <v-text-field outlined dense v-model="compare_price"
                                                                    :label="i18n['compare_price']"
                                                                    :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <v-text-field outlined dense v-model="form_number"
                                                                    :label="i18n['form_number']"
                                                                    :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <v-text-field outlined dense v-model="form_submissions"
                                                                    :label="i18n['form_submission']"
                                                                    :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <v-text-field outlined dense v-model="form_views"
                                                                    :label="i18n['form_views']"
                                                                    :class="`${arabic ? 'arFont' : 'enFont'}`" required
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-btn color="success" @click="addField" class="mb-2"
                                                                    :class="{ 'arFont': arabic, 'enFont': !arabic }"
                                                                    small>{{ i18n['add_feature'] }}</v-btn>

                                                                <!-- Dynamic fields section -->
                                                                <v-expansion-panels accordion>
                                                                    <v-expansion-panel
                                                                        v-for="(field, index) in features" :key="index"
                                                                        class="mb-2 mt-2">
                                                                        <v-expansion-panel-header
                                                                            :class="{ 'arFont': arabic, 'enFont': !arabic }">{{
                                                                    i18n['feature'] }} {{ index + 1 }}
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content>
                                                                            <v-row>
                                                                                <v-col cols="12">
                                                                                    <v-text-field outlined dense
                                                                                        v-model="field.feature"
                                                                                        :label="i18n['feature']"
                                                                                        :class="`${arabic ? 'arFont' : 'enFont'}`"
                                                                                        required
                                                                                        :rules="[rules.required]"></v-text-field>
                                                                                </v-col>
                                                                                <v-col cols="6">
                                                                                    <v-btn x-small icon color="error"
                                                                                        @click="removeField(index)">
                                                                                        <v-icon
                                                                                            size="35">delete_forever</v-icon>
                                                                                    </v-btn>


                                                                                </v-col>
                                                                                <v-col cols="6">
                                                                                    <v-switch v-model="field.available"
                                                                                        :class="[{ 'arFont': arabic, 'enFont': !arabic }]"
                                                                                        label="Available"
                                                                                        color="success">
                                                                                    </v-switch>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-btn color="success" @click="addField_ar" class="mb-2"
                                                                    :class="{ 'arFont': arabic, 'enFont': !arabic }"
                                                                    small>{{ i18n['add_feature_ar'] }}</v-btn>

                                                                <v-expansion-panels accordion>
                                                                    <v-expansion-panel
                                                                        v-for="(field, index) in features_ar"
                                                                        :key="index" class="mb-2 mt-2">
                                                                        <v-expansion-panel-header
                                                                            :class="{ 'arFont': arabic, 'enFont': !arabic }">
                                                                            {{ i18n['feature_ar'] }} {{ index + 1 }}
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content>
                                                                            <v-row>

                                                                                <v-col cols="12">
                                                                                    <v-text-field outlined dense
                                                                                        v-model="field.feature_ar"
                                                                                        :label="i18n['feature_ar']"
                                                                                        :class="`${arabic ? 'arFont' : 'enFont'}`"
                                                                                        required
                                                                                        :rules="[rules.required]"></v-text-field>
                                                                                </v-col>
                                                                                <v-col cols="6">
                                                                                    <v-btn x-small icon color="error"
                                                                                        @click="removeField_ar(index)">
                                                                                        <v-icon
                                                                                            size="35">mdi-delete-forever</v-icon>

                                                                                    </v-btn>
                                                                                </v-col>

                                                                                <v-col cols="6">

                                                                                    <v-switch
                                                                                            v-model="field.available_ar"
                                                                                            :class="[{ 'arFont': arabic, 'enFont': !arabic }]"
                                                                                            label="Available"
                                                                                            color="success">
                                                                                        </v-switch>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </v-col>
                                                        </v-row>

                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-btn small color="success" type="submit" block
                                                            :class="{ 'arFont': arabic, 'enFont': !arabic }">{{
                                                            i18n['add_plan'] }}</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>

                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    menu: false,

    components: {

    },
    data() {
        return {
            title: "",
            title_ar: "",
            description: "",
            description_ar: "",
            price_id: this.is_free ? '' : this.price_id,
            price: "",
            compare_price: "",
            is_free:false,
            formErrors: {},
            features: [],
            features_ar: [],
            loading: false,
            form_number:"",
            form_submissions:"",
            form_views:"",
            rules: {
                    required: value => !!value || this.i18n['required'],
                    string: value => (typeof value === 'string' || value instanceof String) || this.i18n['mustBeAString'],
                    number: value => !isNaN(parseFloat(value)) && isFinite(value) || this.i18n['mustBeANumber'],
                    requiredIfNotFree: value => this.is_free || (!!value && value.length > 0) || this.i18n['required'],

                },

        };
    },
    watch: {

    },
    methods: {

        addField() {
            this.features.push({
                feature: '',
                available: false // Default as not available

            });
        },

        removeField(index) {
            this.features.splice(index, 1);
        },
        addField_ar() {
            this.features_ar.push({ feature_ar: "",   available_ar: false });
        },
        removeField_ar(index) {
            this.features_ar.splice(index, 1);
        },

        languageDisplay(lang) {
            return lang === 'ar' ? 'Arabic' : 'English';
        },

        resetData() {

        },

        submitPlans() {
    const planData = {
        title: this.title,
        title_ar: this.title_ar,
        description: this.description,
        description_ar: this.description_ar,
        price_id: this.price_id,
        price: this.price,
        form_number: this.form_number,
        form_submissions: this.form_submissions,
        form_views: this.form_views,
        compare_price: this.compare_price,
        is_free: this.is_free,
        features: this.features.map(f => ({ feature: f.feature, available: f.available })),
        features_ar: this.features_ar.map(f => ({ feature_ar: f.feature_ar, available_ar: f.available_ar })),
    };

    if (this.$refs.form.validate()) {
        this.loading = true;

        // Prepare the payload for the postResource action
        const payload = {
            resource: "/store/plans", // Assuming this is the correct resource path
            value: planData, // Assuming this is the data to be sent
        };

        // Dispatch the postResource action with the payload
        this.$store.dispatch('postResource', payload)
            .then(() => {
                this.loading = false;
                this.$router.push({ name: 'plan_list' });
                this.resetData();
            })
            .catch((error) => {
                this.loading = false;
                console.error("Error during plan submission:", error);
                if (error.response && error.response.status === 422) {
                    this.errorMessage = "Validation error: " + JSON.stringify(error.response.data.errors);
                } else {
                    this.errorMessage = "An unexpected error occurred.";
                }
            });
    } else {
        this.errorMessage = "Please correct the errors before submitting the plan.";
    }
}







    },
    computed: {
        language() {
            return this.$store.state.language;
        },
        i18n() {
            return this.$store.state.i18n[this.$store.state.language];
        },
        arabic() {
            if (this.$store.state.language == "ar")
                return true;
        },


    },


}
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
</style>